import { FC } from 'react';
import LazyLoad from 'react-lazyload';
import { useTranslation } from 'react-i18next';

import styles from './SupportersForPro.module.scss';

const LAZY_LOAD_OFFSET = 200;

/**
 * @remarks
 * Forked (Styled at Ticket PROD-1853) version of "Supporters" component.
 * Original: `src/modules/marketing-pages/components/LandingPage/Supporters`
 *
 * TODO: merge this component into original, then resolve this fork.
 */
export const SupportersForPro: FC = () => {
  const { t } = useTranslation('marketingPages');
  return (
    <div className={styles.container} data-test-id="supporters-section">
      {/* The word Supporters is intentionally English, regardless of EN / JA by Hayato */}
      <h2 className={styles['supporters-title']}>Supporters</h2>
      <div className={styles['supporters-images']}>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.smbc')}
            className={styles['supporters-image-smbc']}
            height={22}
            src="/static/images/shareholders-logo/smbc.png"
            width={256}
          />
        </LazyLoad>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.mizuho')}
            className={styles['supporters-image-mizuho']}
            height={34}
            src="/static/images/shareholders-logo/mizuho.png"
            width={151}
          />
        </LazyLoad>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.mitsubishi')}
            className={styles['supporters-image-mitsubishi']}
            height={45}
            src="/static/images/shareholders-logo/mitsubishi.png"
            width={151}
          />
        </LazyLoad>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.persol')}
            className={styles['supporters-image-persol']}
            height={44}
            src="/static/images/shareholders-logo/persol.png"
            width={151}
          />
        </LazyLoad>
      </div>
      <hr className={styles['supporters-divider']} />
    </div>
  );
};

export default SupportersForPro;
